import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import {
    userSearchResultAuditDataSelector,
    userSearchResultAuditResultSelector,
} from '../../slices/user-search-result-audit.slice';

type Props = {
    userId: number,
};

export const LastModificationReasonCell = ({userId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultAuditDataSelector);
    const result = useSelector(userSearchResultAuditResultSelector);

    const reason = useMemo(
        () => result?.data[userId]?.lastUpdated.modifierReason,
        [result, userId],
    );

    if (isLoading || loadingError || !reason) {
        return null;
    }

    return (
        <EllipsisTextHint title={reason}>{reason}</EllipsisTextHint>
    );
};
